export default {
  'sendverificationsms.sendverificationsms': 'RICHIEDI IL CODICE DI VERIFICA',
  'sendverificationsms.maintext':
    'Facendo clic sul pulsante Inviami SMS riceverai un messaggio sul tuo telefono registrato che contiene un codice di verifica che ti consente di registrarti',
  'sendverificationsms.sendsms': 'PER FAVORE, INVIAMI SMS',
};
